import React from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import PsychologyIcon from '@mui/icons-material/Psychology';
import TuneIcon from '@mui/icons-material/Tune';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import DevicesIcon from '@mui/icons-material/Devices';
import SecurityIcon from '@mui/icons-material/Security';
import Grid from '@mui/material/Grid';
import { useLanguage } from '../contexts/LanguageContext';
import { Reveal, SpotCard, Glow, GridTexture, BRAND } from './premium';

const FeaturesSection: React.FC = () => {
  const { t } = useLanguage();

  const featureIcons = [
    <PsychologyIcon />, <TuneIcon />, <AnalyticsIcon />,
    <RocketLaunchIcon />, <DevicesIcon />, <SecurityIcon />,
  ];

  return (
    <Box sx={{ position: 'relative', overflow: 'hidden', py: { xs: 9, md: 13 }, backgroundColor: '#F6FAFF' }}>
      <Glow color="#6DABE4" top="-10%" right="-8%" size={460} opacity={0.14} />
      <GridTexture opacity={0.045} />
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Reveal>
          <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
            <Box sx={{ width: 40, height: 3, borderRadius: 3, background: 'linear-gradient(135deg,#0055B8,#6DABE4)', mx: 'auto', mb: 2.5 }} />
            <Typography component="h2" sx={{ fontSize: { xs: '2rem', md: '2.6rem' }, fontWeight: 300, color: '#1A2332', letterSpacing: '-0.01em', textWrap: 'balance' }}>
              {t.features.title}
            </Typography>
          </Box>

          <Grid container spacing={{ xs: 3, md: 4 }}>
            {t.features.items.map((feature, index) => (
              <Grid size={{ xs: 12, sm: 6, lg: 4 }} key={index}>
                <SpotCard sx={{ height: '100%', textAlign: 'center', p: { xs: 3, md: 4 }, borderRadius: '18px', border: '1px solid #E6EEF9', boxShadow: '0 10px 30px -16px rgba(0,85,184,0.12)' }}>
                  <Box
                    sx={{
                      display: 'flex', justifyContent: 'center', alignItems: 'center',
                      width: 64, height: 64, mx: 'auto', mb: 3, borderRadius: '16px',
                      background: 'linear-gradient(135deg,rgba(0,85,184,0.1),rgba(109,171,228,0.12))',
                      color: BRAND, '& svg': { fontSize: '2rem' },
                    }}
                  >
                    {featureIcons[index]}
                  </Box>
                  <Typography variant="h6" sx={{ mb: 1.5, fontWeight: 600, color: '#1A2332', fontSize: { xs: '1.125rem', md: '1.25rem' } }}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#4A5568', lineHeight: 1.65, fontSize: { xs: '0.875rem', md: '1rem' } }}>
                    {feature.description}
                  </Typography>
                </SpotCard>
              </Grid>
            ))}
          </Grid>
        </Reveal>
      </Container>
    </Box>
  );
};

export default FeaturesSection;
